exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".blank[data-v-05dc51f8]{display:flex;flex-direction:column}.blank__title[data-v-05dc51f8],.blank__top[data-v-05dc51f8]{border-top:1px solid #d2d5d9;background:#fff}.blank__inner[data-v-05dc51f8]{display:flex;flex-direction:column;flex-grow:1}", ""]);

